import { render, staticRenderFns } from "./OriginCenter.vue?vue&type=template&id=09916c22&scoped=true"
import script from "./OriginCenter.vue?vue&type=script&lang=js"
export * from "./OriginCenter.vue?vue&type=script&lang=js"
import style0 from "./OriginCenter.vue?vue&type=style&index=0&id=09916c22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09916c22",
  null
  
)

export default component.exports